const circleWrapper = document.getElementById("circle_wrapper");
const circleTexts = document.querySelectorAll(".circle-efficiency__elementsTitle p");
const circleIcons = document.querySelectorAll(".circle-element__icon");

let intervalId = null;
let timeoutIds = [];
let isRunning = false;

if (circleWrapper) {
  const observerCircle = new IntersectionObserver(
    ([entry]) => {
      const isMobile = window.innerWidth <= 1279;

      if (entry.isIntersecting) {
        if (!isRunning) {
          isRunning = true;

          if (isMobile) {
            const delayPerItem = 1000;
            const totalItems = circleTexts.length;

            intervalId = setInterval(() => {
              startAnimation();
            }, totalItems * delayPerItem + 1000);

            startAnimation();
          } else {
            startAnimation();
          }
        }
      } else {
        stopAllAnimations();
      }
    },
    { threshold: 0 }
  );

  observerCircle.observe(circleWrapper);
}

function startAnimation() {
  const isMobile = window.innerWidth <= 1279;

  if (!circleTexts.length || !circleIcons.length) return;

  resetElements();

  const indices = shuffleIndices(circleTexts.length);
  const delay = isMobile ? 1000 : 1000;

  indices.forEach((i, index) => {
    const timeoutId = setTimeout(() => {
      if (isMobile) {
        resetElements();
        circleTexts[i].style.opacity = '1';
        circleTexts[i].style.transform = 'scale(1)';
      }

      circleIcons[i].style.opacity = '1';
      circleIcons[i].style.transform = 'scale(1)';
    }, index * delay);

    timeoutIds.push(timeoutId);
  });
}

function stopAllAnimations() {
  clearInterval(intervalId);
  intervalId = null;

  timeoutIds.forEach(id => clearTimeout(id));
  timeoutIds = [];

  isRunning = false;
  resetElements();
}

function resetElements() {
  circleTexts.forEach(text => {
    text.style.opacity = '0';
    text.style.transform = 'scale(0)';
  });

  circleIcons.forEach(icon => {
    icon.style.opacity = '0';
    icon.style.transform = 'scale(0)';
  });
}

function shuffleIndices(length) {
  const arr = Array.from({ length }, (_, i) => i);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
